<template>
  <section class="container lg:mx-0 lg:px-0">
    <!-- <div class="mt-10 mb-2 text-base italic font-medium font-ff-good-pro-cond">
      {{ $t("common.your_result") }}
    </div> -->
    <div
      class="flex flex-col mt-[21px] gap-10 p-5 rounded-md md:grid md:grid-cols-6 lg:grid-cols-12 bg-dark-gray-100"
    >
      <div class="flex gap-3 md:col-span-4">
        <BikeModel class="w-[46px] h-[46px]" />
        <div class="flex flex-col">
          <span
            class="text-sm font-bold uppercase text-dark-gray-600 font-ff-good-pro-cond"
          >
            {{ $t("common.bike_model") }}
          </span>
          <span
            class="text-base font-medium text-black uppercase font-ff-good-pro-cond"
          >
            {{ calculateBikeSizeStore.bikeModel.product_name }}
          </span>
        </div>
      </div>
      <div class="flex gap-3 md:col-span-4">
        <FrameSize class="w-[46px] h-[46px]" />
        <div class="flex flex-col">
          <span
            class="text-sm font-bold uppercase text-dark-gray-600 font-ff-good-pro-cond"
          >
            {{ $t("common.frame_size") }}
          </span>
          <span
            class="text-base font-medium text-black uppercase font-ff-good-pro-cond"
          >
            <template
              v-for="(size, i) in calculateBikeSizeStore.bikeModel.size_names"
              :key="i"
            >
              <span v-if="i > 0">,</span>
              {{ size }}
            </template>
          </span>
        </div>
      </div>
      <div class="flex gap-3 md:col-span-4">
        <SaddleHeight class="w-[46px] h-[46px]" />
        <div class="flex flex-col">
          <span
            class="text-sm font-bold uppercase text-dark-gray-600 font-ff-good-pro-cond"
          >
            {{ $t("common.saddle_height") }}
          </span>
          <span
            class="text-base font-medium text-black uppercase font-ff-good-pro-cond"
          >
            {{ calculateBikeSizeStore.bikeModel.saddle_height }}
            &nbsp; {{ calculateBikeSizeStore.form.unit }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useMainStore } from "~/store";
import { useCalculateBikeSizeStore } from "~/store/calculatebikesize";
import BikeModel from "~/assets/svg/calculate-size/bike-model.svg?component";
import FrameSize from "~/assets/svg/calculate-size/frame-size.svg?component";
import SaddleHeight from "~/assets/svg/calculate-size/saddle-height.svg?component";

const store = useMainStore();
const calculateBikeSizeStore = useCalculateBikeSizeStore();
</script>